<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>{{job?.title}}</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>{{job?.title}}</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>{{job?.title}}</h3>
                    <p>{{job?.location?.locationName}}
                    </p>
                    <p>Job Id: {{job?.id}}
                    </p>
                    <h3>Job Category:</h3>
                    <p>{{job?.jobCategory.jobCategoryName}}
                    </p>
                    <h3>Qualifications:</h3>
                    <p>{{job?.qualifications}}
                    </p>
                    <h3>Technical Skills:</h3>
                    <p>{{job?.technicalSkills}}
                    </p>
                    <h3>Responsiblity:</h3>
                    <p [innerHTML]="job?.responsiblity">
                    </p>

                    <h3>Shift:</h3>
                    <p>{{job?.jobShift.jobShiftName}}
                    </p>

                    <h3>Travel:</h3>
                    <p>{{job?.travel|yesNo}}
                    </p>

                    <h3>About MicroSync Technologies:</h3>
                    <p [innerHTML]="job?.about">
                </div>
                <div class="option-item">
                    <a [routerLink]="['/applyjob', job?.id]" class="default-btn">Apply</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/careers" class="active">Related Jobs</a></li>
                        <li *ngFor="let job of jobs"><a [routerLink]="['/jobdetails', job?.id]">{{job.title}},
                                {{job.location.locationName}}</a></li>
                    </ul>
                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->